import React, {useState} from "react";
import {
  EditPageContainer,
  Page,
  withServerErrors,
} from "components/common";
import GetBack from "components/refactoring/BackButton";
import { compose } from "recompose";
import { EditForm } from "../EditForm";
import { useTranslation } from "react-i18next";
import LoadingMsg from "components/common/LoadingMsg";


export const AppEdit = ({
  mode,
  item,
  match,
}) => {

  const {t} =  useTranslation()

  const codeOptions = [
    {value: "salla", label: "Salla"},
    {value: "zid", label: "Zid"},
    {value: "marn", label: "Marn"},
    {value: "rahatech", label: "Rahatech"},
    {value: "apicbase", label: "Apicbase"},
  ]

  return (
    <Page title={t(`${mode} Application`)}>
      <GetBack styleClass="my-2"/>
      <EditForm 
        type="Application"
        options={codeOptions} 
        item={item} 
        mode={mode} 
        match={match} 
        t={t} 
        pushURL="/core/app" 
      />
    </Page>
  );
};

const enhance = compose(
  withServerErrors(),
  EditPageContainer({
    url: "core/hesaab_application",
  }),
);

export default enhance(AppEdit);
